// extracted by mini-css-extract-plugin
export default {"icons":"SocialMedia_icons__wGEXV"};